var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye 1",
    clipPath: "url(#clip0_3939_2678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 6.86646C10.5039 6.86646 4.61297 10.4205 0.266032 16.1932C-0.0886775 16.6662 -0.0886775 17.3269 0.266032 17.7999C4.61297 23.5796 10.5039 27.1336 17 27.1336C23.4961 27.1336 29.387 23.5796 33.734 17.8068C34.0887 17.3339 34.0887 16.6731 33.734 16.2002C29.387 10.4205 23.4961 6.86646 17 6.86646ZM17.466 24.136C13.1538 24.4072 9.59282 20.8532 9.86407 16.534C10.0866 12.973 12.973 10.0867 16.534 9.8641C20.8462 9.59285 24.4072 13.1469 24.1359 17.466C23.9064 21.0201 21.02 23.9064 17.466 24.136ZM17.2504 20.8392C14.9274 20.9853 13.0078 19.0727 13.1608 16.7497C13.279 14.83 14.837 13.2791 16.7566 13.1539C19.0796 13.0078 20.9992 14.9205 20.8462 17.2435C20.721 19.17 19.163 20.721 17.2504 20.8392Z",
    fill: "current"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3939_2678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.319dadd9a95c44877e7bf8101c3cb7af.svg";
export { ForwardRef as ReactComponent };